import { createFileRoute, notFound } from '@tanstack/react-router';
import { RequirePermission } from '../../features/auth/RequirePermission';
import { MemberDetailPage } from '../../features/members/MemberDetailPage';

export const Route = createFileRoute('/_app/members/$userId')({
  params: {
    parse: ({ userId }) => {
      if (!/^[0-9a-f-]{36}$/i.test(userId)) throw notFound();
      return { userId };
    },
  },
  component: function MemberRoute() {
    const { userId } = Route.useParams();
    return (
      <RequirePermission permission="team.view">
        <MemberDetailPage userId={userId} />
      </RequirePermission>
    );
  },
});
